export default __webpack_public_path__ + "static/media/16.8ab46448.jpg";